import * as types from './action-types';
import api from '../utils/api';
import getAuth from '../utils/get-auth';

/**
 * Request the current available Steam key count from the service.
 */
export const requestSteamKeyCount = () => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.ADMIN_REQUEST_STEAM_KEY_COUNT,
      payload: api(`/steam-tokens/unassigned/count`, {
        headers: { 'Authorization': `JWT ${auth}`}
      })
    });
  };
};

/**
 * Request the addition of the given Steam keys to the service.
 * @param {Array<String>} keys A list of valid keys to add to the service.
 */
export const requestAddSteamKeys = (keys) => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.ADMIN_REQUEST_ADD_STEAM_KEYS,
      payload: api(`/steam-tokens`, {
        method: 'POST',
        headers: { 'Authorization': `JWT ${auth}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ tokens: keys })
      })
    });
  };
}

/**
 * Request the list of unapproved invites.
 */
export const requestPendingInvites = () => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.ADMIN_REQUEST_PENDING_INVITES,
      payload: api(`/pending-invites`, {
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  };
};

export const requestApproveInvite = (invite) => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.ADMIN_REQUEST_APPROVE_INVITE,
      payload: api(`/invites/${invite.id}/approve`, {
        method: 'POST',
        headers: { 'Authorization': `JWT ${auth}` }
      })
    })
  };
};

export const requestCancelInvite = (invite) => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.ADMIN_REQUEST_CANCEL_INVITE,
      payload: api(`/invites/${invite.id}/cancel`, {
        method: 'POST',
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/admin-actions.js